import { render, staticRenderFns } from "./GradleMD.vue?vue&type=template&id=708691bd&scoped=true"
import script from "./GradleMD.vue?vue&type=script&lang=js"
export * from "./GradleMD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708691bd",
  null
  
)

export default component.exports